import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  useFetchArticleQuery,
  useUpdateMetricsMutation,
} from "../../../store/";
import { SdfAlert, SdfSegmentedControl } from "@synerg/react-components";
import { getBreadcrumb } from "../../../utility/articlesUtils";
import Breadcrumb from "../../../components/Breadcrumb";
import { NotFound } from "../../NotFound";
import { GuideContent } from "../../../components/guides/GuideContent";
import PageLoading from "../../../components/shared/PageLoading";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { SEGMENTS, PARTNER_SEGMENTS } from "../../../components/welcome-page/utility/constants";
import { useSearchParams } from "react-router-dom";

export function ViewGuidePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  const { type, guideId } = useParams();
  const { isFetching, data: guide } = useFetchArticleQuery({
    index: "guides",
    id: guideId,
  });
  const [breadcrumb, setBreadcrumb] = useState("");
  const [visibility, setVisibility] = useState(false);
  const [isPartnerGuide, setIsPartnerGuide] = useState(false);
  const [partnerRegion, setPartnerRegion] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [region, setRegion] = useState(
    searchParams.has("international") ? 1 : 0,
  );

  const getTitle = (articleItem) => {
    return (
      articleItem?.title ||
      articleItem?._source?.title ||
      articleItem?._id ||
      "No Title"
    );
  };

  const getAbstract = (articleItem) => {
    return articleItem?.abstract || articleItem?._source?.abstract || "";
  };
  const handlePartnerTabChange = (newRegion) => {
    setPartnerRegion(newRegion);
    const isGettingStartedPartnerPath = currentPath.startsWith("/getting-started/getting-started-as-a-partner");
    const isPartnerQSPath = currentPath.startsWith("/guides/quick-start-guides/adp-marketplace-partners");
    const basePath = isGettingStartedPartnerPath
      ? "/getting-started/getting-started-as-a-partner/guides/adp-marketplace-integration-guides"
      : isPartnerQSPath
      ? "/guides/quick-start-guides/adp-marketplace-partners/adp-marketplace-integration-guides"
      : "/guides/adp-marketplace-integration-guides";
    const guideSlug = newRegion === 1
      ? "adp-marketplace-esi---partner-development-learning-guide"
      : "partner-development-learning-guide";
    navigate(`${basePath}/${guideSlug}`);
  };

  const handleTabChange = (newRegion) => {
    setRegion(newRegion);
    if (newRegion === 1) {
      searchParams.set("international", "1");
    } else {
      searchParams.delete("international");
    }
    setSearchParams(searchParams);
    const isInternational = newRegion === 1;

    const isGettingStartedPath = currentPath.includes("/getting-started");
    const basePath = isGettingStartedPath
      ? "/getting-started/getting-started-as-a-client/guides/api-guides"
      : "/guides/quick-start-guides/adp-api-central-for-clients/api-guides";
        const guideSuffix = isInternational
      ? "api-central-quick-start-guide-international"
      : "api-central-quick-start-guide";
        const navigationPath = `${basePath}/${guideSuffix}`;
    navigate(navigationPath);
  };

  useEffect(() => {
    setRegion(0);
    const isInternational = currentPath.endsWith("-international");
    const isPartnerPath = currentPath.startsWith("/getting-started/getting-started-as-a-partner");
    const isPartnerQuickStartPath = currentPath.startsWith("/guides/quick-start-guides/adp-marketplace-partners");
    const isInternationalPartnerGuide = guideId === "adp-marketplace-esi---partner-development-learning-guide";
    const isNAPartnerGuide = guideId === "partner-development-learning-guide";
    const isClientPath = currentPath.startsWith("/getting-started/getting-started-as-a-client");
    const isApiGuidesPath = currentPath.startsWith("/guides/quick-start-guides/adp-api-central-for-clients");
    if (isInternational) setRegion(1);

    const isAnyPartnerPath = isPartnerPath || isPartnerQuickStartPath || isInternationalPartnerGuide || isNAPartnerGuide;
    setIsPartnerGuide(isAnyPartnerPath);
    if (isAnyPartnerPath) {
      setPartnerRegion(isInternationalPartnerGuide ? 1 : 0);
      window.scrollTo(0, 0);
    }

    const newBreadcrumb = isAnyPartnerPath ? "getting-started-partner"
      : isClientPath ? "getting-started-as-a-client"
      : isApiGuidesPath ? "api-guides"
      : type;
    setBreadcrumb(newBreadcrumb);
    setVisibility(currentPath.includes("api-central-quick-start-guide"));
  }, [currentPath]);

  const breadcrumbPath = getBreadcrumb(breadcrumb, getTitle(guide));
  const [updateMetrics, results] = useUpdateMetricsMutation();
  useEffect(() => {
    updateMetrics({ id: guideId, index: "guides" });
  }, []);
  return (
    <>
      <PageLoading loading={isFetching}>
        <div className="px-8" >
          <Breadcrumb path={breadcrumbPath} />
          {visibility && <div className="flex justify-center mb-4 mt-6">
            <SdfSegmentedControl
              selectedIndex={region}
              items={SEGMENTS}
              className="mb-12"
              onSdfChange={(event) => {
                handleTabChange(event.detail);
              }}
            ></SdfSegmentedControl>
          </div>}
          {isPartnerGuide && <div className="flex justify-center mb-4 mt-6">
            <SdfSegmentedControl
              selectedIndex={partnerRegion}
              items={PARTNER_SEGMENTS}
              className="mb-12"
              onSdfChange={(event) => {
                handlePartnerTabChange(event.detail);
              }}
            ></SdfSegmentedControl>
          </div>}

          {results.error && (
            <SdfAlert closeable status="error">
              An error occurred when updating metrics for this document
            </SdfAlert>
          )}
          {!guide && <NotFound />}
          {guide && <GuideContent content={guide} guideId={guideId} exportTitle={getTitle(guide)} exportAbstract={getAbstract(guide)} />}
        </div>
      </PageLoading>
    </>
  );
}
